export const getPattern = (type: string) => {
  switch (type) {
    case 'email': {
      return {
        value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
        message: 'La respuesta debe ser un correo electrónico.'
      };
    }
    case 'url': {
      return {
        value: /^http[s]?:\/\//,
        message: 'La respuesta debe ser una URL.'
      };
    }
    default: {
      return {};
    }
  }
};
